/* eslint-disable react/prop-types */
import React, {useState} from "react";

import {FiChevronDown} from "react-icons/fi"
import {ModalApp} from "components/Modal";
import Button from "components/Button";
import {payments} from 'utils'

export default function Offers({ offers, changeOffers }) {
    const [open, setOpen] = useState(false);
    const [offersData, setOffersData] = useState(offers)

    const handleModal = () => {
        changeOffers(offersData)
        setOpen(!open);
    };

    const handleChange = (event) => {
        setOffersData(event)
    };

    return (
        <>
            <div className="input-group" onClick={handleModal}>
                <label className="d-flex flex-grow-1 label-custom">Ver ofertas em</label>
                <span className="input-group-custom pe-0 gap-2">
                    <span className="color-custom d-flex align-items-center gap-2">
                        <span>
                            { offers === 'points' && 'Pontos' }
                            { offers === 'cash' && 'Dinheiro' }
                        </span>
                        <FiChevronDown className="svg-sm"/>
                    </span>
                </span>
            </div>
            <ModalApp show={open} handleModal={handleModal}>
                <p className="label-modal mb-4">Selecione as formas de pagamento</p>
                <div className="px-4 pt-4 d-grid gap-4">
                    { payments.map((item) =>
                        <div className="input-group" key={item.name}>
                            <label className="label-custom">{item.label}</label>
                            <span className="input-group-custom">
                               <input
                                   className="custom-radio"
                                   type="radio"
                                   value={item.name}
                                   name="offers"
                                   defaultChecked={offers === item.name}
                                   onChange={(e) => handleChange(e.target.value)}
                               />
                            </span>
                        </div>
                    )}

                    <div className="my-4 d-flex justify-content-center">
                        <Button type="button" width="200px" className="text-uppercase" onClick={handleModal}>
                            CONTINUAR
                        </Button>
                    </div>
                </div>
            </ModalApp>
        </>
    );
}
